import { ProductProvider } from '@/components/ProductContext.tsx'
import { ReservationProvider } from '@/components/ReservationContext.tsx'
import { HotelReservationViewer } from '@/features/reservation-viewer/ui/HotelReservationViewer'
import { HairSalonReservationViewer } from '@/widgets/HairSalonCalendar/ui/HairSalonReservationViewer'
import { Sidebar, SidebarProvider } from '@/widgets/sidebar'

import { ReservationModalProvider, useReservationModal } from './components/ReservationModalContext'

function ReservationModal() {
    const { reservationInModal, openReservationModal } = useReservationModal()

    if (!reservationInModal) return null

    if (reservationInModal.type === 'hotel') {
        return (
            <HotelReservationViewer
                reservation={reservationInModal}
                isOpen={true}
                onClose={() => openReservationModal(null)}
            />
        )
    }

    if (reservationInModal.type === 'peluqueria') {
        return (
            <HairSalonReservationViewer
                reservationId={reservationInModal.id}
                isOpen={true}
                onClose={() => openReservationModal(null)}
            />
        )
    }

    return null
}

export default function PanelInternoLayout({ children }: { children: React.ReactNode }) {
    return (
        <SidebarProvider>
            <ReservationModalProvider>
                <ReservationProvider>
                    <ProductProvider>
                        <div className='flex h-screen bg-gray-100'>
                            <Sidebar />
                            <div className='flex-1 overflow-auto'>{children}</div>
                            <ReservationModal />
                        </div>
                    </ProductProvider>
                </ReservationProvider>
            </ReservationModalProvider>
        </SidebarProvider>
    )
}
